import { RouteComponentProps } from '@reach/router';
import React, { FC } from 'react';

import { CaseCount } from '../components/CaseCount';
import { DefaultContent } from '../components/DefaultContent';
import { Hero, HeroBackground } from '../components/Hero';
import { PublicRoute } from '../components/PublicRoute';
import { SEO } from '../components/Seo';
import { ContactForm } from '../forms/ContactForm';
import { Title } from '../styles/common';

const Contact: FC<RouteComponentProps> = (props) => {
  return (
    <PublicRoute {...props}>
      <SEO title="Contact Us" description="Want more information on Hypercite? Contact us for a free consultation!" />
      <Hero className="flex flex-col items-center w-full">
        <Title className="text-center mt-16 mb-12">
          Automatically Hyperlink Your Citations to the Record, Prior Briefing, and More In Just Seconds
        </Title>
        <HeroBackground />
        <div className="w-full flex px-4">
          <div className="w-full md:w-2/3 lg:w-1/2 ml-auto mr-auto">
            <ContactForm />
          </div>
        </div>

        <CaseCount />
      </Hero>

      <DefaultContent />
    </PublicRoute>
  );
};

export default Contact;
